module.exports = __webpack_public_path__ + "img/fenxi-3.0f61ea9f.png";